export interface ArticleGroupDiscount {
    id: string;
    name: string;
    externalGroupId: string;
    description: string;
    discountPercentage: number;
    createdAt: Date | null;
    updatedAt: Date | null;
}

export const defaultArticleGroupDiscount: ArticleGroupDiscount =
{
    id: "",
    name: "",
    externalGroupId: "",
    description: "",
    discountPercentage: 0,
    createdAt: null,
    updatedAt: null
}